/**
 * Thin local cache for workspace health-check data (non-architect uses only).
 * Architect tenant context health probe is server-cached at connect (E.IMPL.5 Q-06).
 *
 * @type {{ orgUrl: string, health: object } | null}
 */
let snapshot = null;

/**
 * @param {string} orgUrl
 * @param {object} [health]
 */
export function setTenantHealthSnapshot(orgUrl, health) {
  if (!orgUrl || !health || health.ok !== true) {
    snapshot = null;
    return;
  }
  snapshot = { orgUrl: String(orgUrl).trim(), health };
}

/** @deprecated Architect reads connect-time probe from server session; returns null for prompts. */
export function getTenantHealthSnapshot() {
  return null;
}

export function clearTenantHealthSnapshot() {
  snapshot = null;
}

/** @returns {{ orgUrl: string, health: object } | null} */
export function getTenantHealthData() {
  return snapshot;
}
